/* HomLoom COD Form - exact price from the server (v1, 02 Nov 2026)
   The form asks the order server what Shopify will really charge (country price list, automatic discounts, add-ons)
   and shows that total, so "Pay at your door" always matches the order (e.g. Oman 3-pack = AED 169).
   Safe: only runs when the server says it supports price checks (version text contains "quote"). */
(function () {
  var root = document.getElementById('hl-cod');
  if (!root || root.__hlq) return;
  root.__hlq = 1;
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('hl-cod-config').textContent); } catch (e) {}
  if (!cfg.endpoint) return;
  var EP = cfg.endpoint.replace(/\/$/, '');
  var LEN = { AE: 9, SA: 9, QA: 8, OM: 8, KW: 8, BH: 8 };
  var MF = cfg.moneyFormat || 'Dhs. {{amount}}';
  function fmt(c) {
    var a = (Math.abs(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MF.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, a);
  }
  function q(s, el) { return (el || root).querySelector(s); }
  function val(id) { var e = document.getElementById(id); return e ? String(e.value || '').trim() : ''; }

  var ready = false;
  fetch(EP + '/health').then(function (r) { return r.json(); }).then(function (h) {
    ready = !!(h && h.ok && /quote/i.test(h.version || ''));
    if (ready) refresh();
  }).catch(function () {});

  function payload() {
    var offers = q('[data-hlc-offers]');
    if (!offers || offers.hidden || !q('.hlc__tag', offers)) return null; // cart: Shopify cart already prices it
    var p = cfg.product;
    if (!p || !p.variants || !p.variants.length) return null;
    var cc = (val('hlc-country') || 'AE').toUpperCase();
    var vOn = q('[data-hlc-variants] .is-on');
    var pageV = document.querySelector('.tae-buy-now-button input[name="id"], main form[action*="/cart/add"] [name="id"]');
    var vid = vOn ? Number(vOn.getAttribute('data-vid')) : (pageV && Number(pageV.value)) || p.variants[0].id;
    var tag = q('.hlc__tag.is-on');
    var qty = tag && Number(tag.getAttribute('data-qty')) || 1;
    var pcb = q('#hlc-protection');
    var ad = window.hlcAddons ? window.hlcAddons() : {};
    return {
      quoteOnly: true, variantId: vid, quantity: qty, items: null, discountCodes: null, cartTotal: null,
      name: 'Price Check', phone: new Array((LEN[cc] || 9) + 1).join('5'), country: cc,
      region: cc === 'AE' ? 'DU' : 'Region', city: 'Area', address: 'Price check address',
      notes: '', callPref: 'nocall', protection: !!(pcb && pcb.checked),
      addons: { mysteryBox: ad && ad.mysteryBox ? ad.mysteryBox : null, express2day: ad && ad.express2day ? ad.express2day : null },
      website: ''
    };
  }
  function keyOf(b) { return b ? [b.country, b.variantId, b.quantity, b.protection ? 1 : 0, b.addons.mysteryBox ? 1 : 0, b.addons.express2day ? 1 : 0].join('|') : ''; }

  var cache = {}, pending = {}, timer = 0;
  function ask() {
    if (!ready) return;
    var b = payload();
    var k = keyOf(b);
    if (!k || cache[k] != null || pending[k]) return;
    pending[k] = 1;
    fetch(EP + '/order', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(b) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.ok && j.quote && typeof j.total === 'number') { cache[k] = Math.round(j.total * 100); if (keyOf(payload()) === k) refresh(); } })
      .catch(function () {})
      .then(function () { delete pending[k]; });
  }
  function refresh() {
    var cb = q('#hlc-protection');
    if (cb) cb.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* receipt row that explains the difference */
  var receipt = q('.hlc__receipt');
  var adjRow = null;
  if (receipt) {
    adjRow = document.createElement('div');
    adjRow.className = 'hlc__row';
    adjRow.hidden = true;
    adjRow.innerHTML = '<span data-hlq-lbl></span><span data-hlq-amt></span>';
    var totalRow = q('.hlc__row--total', receipt);
    receipt.insertBefore(adjRow, totalRow);
  }
  var NAMES = { AE: 'UAE', SA: 'Saudi Arabia', QA: 'Qatar', OM: 'Oman', KW: 'Kuwait', BH: 'Bahrain' };

  /* wrap the add-ons hook so the total shown = what the server will charge */
  var inner = window.hlcX;
  window.hlcX = function (base) {
    var extra = inner ? inner(base) : 0;
    var b = payload();
    var k = keyOf(b);
    var delta = 0;
    if (k && cache[k] != null) {
      delta = cache[k] - ((base || 0) + extra);
      if (Math.abs(delta) < 2) delta = 0;
    } else if (k) {
      clearTimeout(timer);
      timer = setTimeout(ask, 300);
    }
    if (adjRow) {
      adjRow.hidden = !delta;
      if (delta) {
        q('[data-hlq-lbl]', adjRow).textContent = delta > 0 ? 'Price for ' + (NAMES[b.country] || b.country) : 'Extra discount';
        q('[data-hlq-amt]', adjRow).innerHTML = (delta > 0 ? '+' : '−') + fmt(delta);
      }
    }
    window.__hlcExtra = extra + delta;
    if (window.hlcPayPaint) setTimeout(window.hlcPayPaint, 0);
    return extra + delta;
  };
  var AR = window.hlcAR || {};
  AR['Extra discount'] = 'خصم إضافي';
  ['UAE', 'Saudi Arabia', 'Qatar', 'Oman', 'Kuwait', 'Bahrain'].forEach(function (n, i) {
    AR['Price for ' + n] = 'السعر في ' + ['الإمارات', 'السعودية', 'قطر', 'عُمان', 'الكويت', 'البحرين'][i];
  });
})();
